export default __webpack_public_path__ + "static/media/linkedin-icon.e65fd24a.png";